<template>
    <billing-account-form dialog-id="create-billing-account" title="Create Billing Account" :account="account">
        <slot slot="submit">
            <div class="block-content block-content-full text-right bg-light">
                <button @click="save()" type="button" class="btn btn-success">Save Changes</button>
            </div>
        </slot>
    </billing-account-form>
</template>

<script>
    import Form from './components/AccountForm';
    import EventBus from "../../../bus/events";

    export default {
        name: "CreateBillingAccount",
        components: {
            'billing-account-form': Form
        },
        mounted() {
        },
        data() {
            return {
                account: {
                    id: '',
                    name: '',
                    type: '',
                    accountNumber: '',
                    currency: 'KES'
                }
            }
        },
        methods: {
            save() {
                if (this.account.type === 'unit') {
                    this.account.currency = 'UNT'
                }
                this.$store.dispatch('createAccount', this.account).then(() => {
                    EventBus.$on('billing-account-created', (account) => {
                        this.account = {
                            id: '',
                            name: '',
                            type: '',
                            accountNumber: '',
                            currency: 'KES'
                        };
                        $('#create-billing-account').modal('hide');
                    })
                });
            }
        }
    }
</script>

<style scoped>

</style>
